import axios from "axios";

const API = (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace(/\/$/, "");

export const fetchCTScanTests = async (token, params = {}) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/ct-scan-tests/`, { headers, params });
  return res.data;
};

export const createCTScanTest = async (token, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.post(`${API}/ct-scan-tests/`, payload, { headers });
  return res.data;
};

export const updateCTScanTest = async (token, id, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.patch(`${API}/ct-scan-tests/${id}/`, payload, { headers });
  return res.data;
};

export const deleteCTScanTest = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  await axios.delete(`${API}/ct-scan-tests/${id}/`, { headers });
};

export const fetchCTScanRecords = async (token, params = {}) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/ct-scan-records/`, { headers, params });
  return res.data;
};

export const createCTScanRecord = async (token, formData) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  if (typeof FormData !== "undefined" && formData instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }
  const res = await axios.post(`${API}/ct-scan-records/`, formData, { headers });
  return res.data;
};

export const updateCTScanRecord = async (token, id, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  if (typeof FormData !== "undefined" && payload instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }
  const res = await axios.patch(`${API}/ct-scan-records/${id}/`, payload, { headers });
  return res.data;
};

export const deleteCTScanRecord = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  await axios.delete(`${API}/ct-scan-records/${id}/`, { headers });
};


